/**
 * Módulo: Fund Filter
 * Funcionalidade dos selects fake: toggle dropdown, seleção de opções, fechar ao clicar fora.
 *
 * Estratégia "portal": ao abrir, o dropdown é movido para document.body com position:fixed,
 * escapando completamente de qualquer stacking context (AOS, transforms, z-index de ancestrais).
 * Ao fechar, retorna ao select original.
 */

// Rastreia todos os pares [select, dropdown] inicializados
const registry = [];

function openDropdown(select, dropdown) {
  const rect = select.getBoundingClientRect();

  document.body.appendChild(dropdown);

  Object.assign(dropdown.style, {
    position: 'fixed',
    top:      `${rect.bottom + 4}px`,
    left:     `${rect.left}px`,
    width:    `${rect.width}px`,
    zIndex:   '10',
    display:  'block',
  });
}

function closeDropdown(select, dropdown) {
  select.appendChild(dropdown);

  Object.assign(dropdown.style, {
    position: '',
    top:      '',
    left:     '',
    width:    '',
    zIndex:   '',
    display:  '',
  });
}

function closeAll(except = null) {
  registry.forEach(({ select, dropdown }) => {
    if (select === except) return;
    if (!select.classList.contains('is-open')) return;
    select.classList.remove('is-open');
    closeDropdown(select, dropdown);
  });
}

export function initFundFilter() {
  const selects = document.querySelectorAll('.fund-filter__select');

  if (!selects.length) return;

  selects.forEach(select => {
    const textEl   = select.querySelector('.fund-filter__select-text');
    const dropdown = select.querySelector('.fund-filter__dropdown');

    if (!dropdown) return;

    registry.push({ select, dropdown });

    const items = dropdown.querySelectorAll('.fund-filter__dropdown-item');

    select.addEventListener('click', (e) => {
      e.stopPropagation();

      const isOpen = select.classList.contains('is-open');

      closeAll(select);

      if (isOpen) {
        select.classList.remove('is-open');
        closeDropdown(select, dropdown);
      } else {
        select.classList.add('is-open');
        openDropdown(select, dropdown);
      }
    });

    items.forEach(item => {
      item.addEventListener('click', (e) => {
        e.stopPropagation();

        const value = item.dataset.value;
        const label = item.textContent.trim();

        if (textEl) textEl.textContent = label;

        items.forEach(i => i.classList.remove('is-selected'));
        item.classList.add('is-selected');

        select.classList.remove('is-open');
        closeDropdown(select, dropdown);

        select.dispatchEvent(new CustomEvent('fund-filter:change', {
          detail: { value, label },
          bubbles: true,
        }));
      });
    });
  });

  // Fecha ao clicar fora
  document.addEventListener('click', () => closeAll());

  // Fecha ao pressionar ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  // Reposiciona ao fazer scroll
  window.addEventListener('scroll', () => {
    registry.forEach(({ select, dropdown }) => {
      if (!select.classList.contains('is-open')) return;
      const rect = select.getBoundingClientRect();
      dropdown.style.top  = `${rect.bottom + 4}px`;
      dropdown.style.left = `${rect.left}px`;
    });
  }, { passive: true });
}
